import { useFeatureConfig } from '@/presentation/composables/common/use-feature-config';
import { useUserInfo } from '@/presentation/composables/user/use-user-info';
import { DetailViewTypeService } from '@/services/detail-view-name-service';
import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import _ from 'lodash';
import { computed } from 'vue';
export const useDefaultViewType = () => {
    const detailViewTypeService = injectService(DetailViewTypeService);
    const { viewTypeList } = useUserInfo();
    const { defaultViewTypeByRegion } = useFeatureConfig();
    const defaultViewType = computed(() => {
        const localViewType = detailViewTypeService.getDetailViewType();
        if (_.includes(viewTypeList.value, localViewType)) {
            return localViewType;
        }
        return defaultViewTypeByRegion;
    });
    function updateLocalViewType(viewType) {
        detailViewTypeService.setDetailViewType(viewType);
    }
    return {
        defaultViewType,
        updateLocalViewType,
    };
};
